import { EnvironmentVariable } from './app-settings'

export class ApiSettings {
  public readonly REACT_APP_API_HOST: string

  constructor(envVariables: EnvironmentVariable) {
    this.REACT_APP_API_HOST = envVariables.REACT_APP_API_HOST as string
  }
}
